/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 30/10/2020
 */

import * as SessionUtils from './../../../core/session_utils.js'

const countStatusRequest = () => {
    return {
        userId: SessionUtils.getUserId(),
        invited: SessionUtils.isGuestUser(),
        sessionUser:SessionUtils.getGuestUserToken()
    }

}

export default countStatusRequest